import React, { Component } from 'react';
export default  class Resume extends Component {
  render() {
    let resumeData = this.props.resumeData;
    return (
      <section id="resume">

         <div className="row education">

            <div className="three columns header-col wow fadeInLeft" data-wow-offset="50" data-wow-delay=".25s">
               <h1><span>Education</span></h1>
            </div>

            <div className="nine columns main-col">
              {
                resumeData.education && resumeData.education.map((item)=>{
                  return(
                    <div className="row item" key={item.UniversityName}>
                       <div className="twelve columns">
                          <h3 className="wow fadeInRight"  data-wow-delay=".25s">{item.UniversityName}</h3>
                          <p className="info wow fadeInDown"  data-wow-delay=".75s">
                          {item.role}
                          <span>&bull;</span> <em className="date">{item.YearOfStart}–{item.YearOfPassing}</em></p>
                          <p>
                          {item.Achievements}
                          </p>
                       </div>
                    </div>
                  )
                })
              }
            </div>
         </div>
         <div className="row work">

            <div className="three columns header-col wow fadeInLeft" data-wow-offset="50" data-wow-delay=".25s">
               <h1><span>Work</span></h1>
            </div>

            <div className="nine columns main-col" data-wow-offset="50" data-wow-delay=".25s">
              {
                resumeData.work && resumeData.work.map((item) => {
                  return(
                    <div className="row item" key={item.Achievements}>
                       <div className="twelve columns">
                          <h3 className="wow fadeInRight" data-wow-delay=".25s">{item.CompanyName}</h3>
                          <p className="info wow fadeIn" data-wow-delay=".75s">
                          {item.role}
                          <span>&bull;</span> <em className="date">{item.MonthOfStart}/{item.YearOfStart} - {item.MonthOfLeaving}{item.ifCurrent}{item.YearOfLeaving}</em></p>
                          <p className="wow fadeIn json-line-break" data-wow-delay=".75s">
                          {item.Achievements}
                          {item.keyPoints}
                          </p>
                       </div>

                    </div>

                  )
                })
              }
            </div>
            <div className="three columns header-col wow fadeInLeft" data-wow-offset="50" data-wow-delay=".25s">
               <h1><span>Certifications</span></h1>
            </div>

            <div className="nine columns main-col" data-wow-offset="50" data-wow-delay=".25s">
              {
                resumeData.certifications && resumeData.certifications.map((item) => {
                  return(
                    <div className="row item" key={item.CertName}>
                       <div className="twelve columns wow fadeInRight" data-wow-delay=".5s">
                          <h3>{item.CertName}</h3>
                          <p className="info">
                          {item.dicipline}
                          <span>&bull;</span> <em className="date">{item.YearOfCompletion}</em></p>
                          <p>
                          {item.Achievements}
                          </p>
                       </div>

                    </div>

                  )
                })
              }
            </div>

         </div>


         <div className="row skill">

            <div className="three columns header-col wow fadeInLeft" data-wow-offset="50" data-wow-delay=".25s">
               <h1><span>Skills</span></h1>
            </div>

            <div className="nine columns main-col" data-wow-offset="50" data-wow-delay=".25s">

               {/* <p>
                {resumeData.skillsDescription}
               </p> */}

   				<div className="bars">

   				   <ul className="skills">
                {
                  resumeData.skills && resumeData.skills.map((item) => {
                    return(
                      <li className="wow fadeInDown" data-wow-delay=".5s" key={item.skillname}>
                      <span className={`bar-expand ${item.skillname.toLowerCase()}`}>
                      </span><em>{item.skillname}</em>
                      </li>
                    )
                  })
                }

   					</ul>

   				</div>

   			</div>

         </div>

      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/resume/resume.js